Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  colorSquidInk: "#232F3E",
  colorTransparent: "rgba(0, 0, 0, 0)",
  colorGray0: "#FFFFFF",
  colorGray50: "#F9FAFA",
  colorGray100: "#F0F1F2",
  colorGray200: "#E7E9E9",
  colorGray300: "#BBC0C1",
  colorGray400: "#949C9C",
  colorGray500: "#697576",
  colorGray600: "#485050",
  colorGray700: "#252829",
  colorGray800: "#0B0C0C",
  colorGrayMuted200: "#ECEDED",
  colorGrayMuted300: "#ABB0B5",
  colorGrayMuted600: "#5B5F5F",
  colorGrayMuted700: "#323838",
  colorGrayTranslucentLight50: "rgba(255, 255, 255, 0.16)",
  colorGrayTranslucentLight100: "rgba(255, 255, 255, 0.22)",
  colorGrayTranslucentLight200: "rgba(255, 255, 255, 0.36)",
  colorGrayTranslucentMid500: "rgba(108, 119, 120, 0.5)",
  colorGrayTranslucentDark50: "rgba(11, 12, 12, 0.04)",
  colorGrayTranslucentDark100: "rgba(11, 12, 12, 0.1)",
  colorGrayTranslucentDark200: "rgba(11, 12, 12, 0.16)",
  colorGrayTranslucentDark300: "rgba(11, 12, 12, 0.26)",
  colorGrayTranslucentDark500: "rgba(11, 12, 12, 0.5)",
  colorBlue50: "#E5F6FB",
  colorBlue100: "#B9E8F7",
  colorBlue200: "#7CCEE9",
  colorBlue300: "#47C2EC",
  colorBlue400: "#00A8E1",
  colorBlue500: "#077398",
  colorBlue600: "#055D7B",
  colorBlue700: "#03384B",
  colorBlue800: "#01222D",
  colorBlueMuted100: "#C1DEE8",
  colorBlueMuted200: "#90C5D7",
  colorBlueMuted300: "#86A4AF",
  colorBlueMuted400: "#204B5A",
  colorBlueMuted500: "#24586A",
  colorBlueMuted600: "#14181D",
  colorOrange50: "#FFF3F0",
  colorOrange100: "#FFDAD1",
  colorOrange200: "#FFA28A",
  colorOrange300: "#FF714D",
  colorOrange400: "#FF6138",
  colorOrange500: "#CB330B",
  colorOrange600: "#932306",
  colorOrange700: "#4F1203",
  colorOrange800: "#310B02",
  colorOrangeMuted100: "#F5CCC2",
  colorOrangeMuted200: "#EFAD9C",
  colorOrangeMuted300: "#BE968C",
  colorOrangeMuted400: "#99351B",
  colorOrangeMuted500: "#8A3823",
  colorOrangeMuted600: "#55190A",
  colorTeal50: "#E6F9FB",
  colorTeal100: "#B5EBF3",
  colorTeal200: "#6ED9EA",
  colorTeal300: "#2DD4ED",
  colorTeal400: "#0AABC4",
  colorTeal500: "#067586",
  colorTeal600: "#045C69",
  colorTeal700: "#023138",
  colorTeal800: "#01171B",
  colorTealMuted100: "#C0DFE5",
  colorTealMuted200: "#8AC6CF",
  colorTealMuted300: "#8AA6AD",
  colorTealMuted400: "#164D55",
  colorTealMuted500: "#185862",
  colorTealMuted600: "#13181C",
  colorGreen100: "#DCF3A0",
  colorGreen300: "#C3EB5E",
  colorGreen400: "#ADE422",
  colorGreen500: "#98C91E",
  colorRed100: "#F9D5E2",
  colorRed300: "#FF7494",
  colorRed400: "#CC0C39",
  colorRed500: "#AD0A30",
  colorYellow100: "#FEF2B8",
  colorYellow300: "#FCDE4D",
  colorYellow400: "#FAD000",
  colorYellow500: "#DCB700",
  colorPink100: "#FFDBE5",
  colorPink200: "#FFB5CA",
  colorPink300: "#FF8CAF",
  colorPink400: "#FF5A94",
  colorPink500: "#DC3C71",
  colorPink600: "#BA1750",
  colorPurple100: "#E9C6E4",
  colorPurple200: "#ECA8E0",
  colorPurple300: "#EC88DC",
  colorPurple400: "#EB64D7",
  colorPurple500: "#C54FB4",
  colorPurple600: "#8C297D",
  colorTurquoise100: "#C3E9E7",
  colorTurquoise200: "#78D9CF",
  colorTurquoise300: "#36C2B4",
  colorTurquoise400: "#2C9F93",
  colorTurquoise500: "#227D74",
  colorTurquoise600: "#1B5F5B",
  colorTangerine100: "#FFE5CB",
  colorTangerine200: "#FFCB96",
  colorTangerine300: "#FFAE5D",
  colorTangerine400: "#FF8F00",
  colorTangerine500: "#D4780C",
  colorTangerine600: "#A45C0A",
  colorViolet100: "#DDC8FF",
  colorViolet200: "#C9A8FF",
  colorViolet300: "#A588FF",
  colorViolet400: "#8169F8",
  colorViolet500: "#614FD9",
  colorViolet600: "#3E36BB",
  colorGold100: "#FFF4D9",
  colorGold200: "#FFE8B1",
  colorGold300: "#FFDB86",
  colorGold400: "#FCC201",
  colorGold500: "#DAA500",
  colorGold600: "#BF8E00",
  colorForest100: "#D6ECC9",
  colorForest200: "#ABD994",
  colorForest300: "#7EC55E",
  colorForest400: "#47B120",
  colorForest500: "#348118",
  colorForest600: "#005C00",
  colorCrimson100: "#FFD9CF",
  colorCrimson200: "#FFB09F",
  colorCrimson300: "#F98771",
  colorCrimson400: "#EE5A46",
  colorCrimson500: "#DE1B1B",
  colorCrimson600: "#AF1F18",
  colorSlate100: "#DADEE2",
  colorSlate200: "#B6BDC6",
  colorSlate300: "#929EAB",
  colorSlate400: "#708090",
  colorSlate500: "#596571",
  colorSlate600: "#434C54"
};